module.exports = __webpack_public_path__ + "static/filmbox-3823c91ea5eb36e8cb230f7e0cb5df31.png";